


























































import * as memberAPI from '@adobe/edex/frontend/api/member';
import Loader from '@adobe/edex/frontend/components/common/loader.vue';
import MemberProfileFollow from '@adobe/edex/frontend/views/member/member-profile-follow.vue';
import MemberProfileExpertise from '@adobe/edex/frontend/views/member/member-profile-expertise.vue';
import MemberProfileInterests from '@adobe/edex/frontend/views/member/member-profile-interests.vue';
import MemberProfileExperience from '@adobe/edex/frontend/views/member/member-profile-experience.vue';
import MemberProfileCard from '@adobe/edex/frontend/views/member/member-profile-card.vue';
import MemberProfileResources from '@adobe/edex/frontend/views/member/member-profile-resources.vue';
import NotFound from '@adobe/edex/frontend/views/not-found.vue';

import { mapMutations, mapState } from 'vuex';
import { getMemberUrl } from '@adobe/edex/ui/shared/utils/routes';

export default {
  seo() {
    return {
      meta: [
        {
          name: 'robots',
          content: 'noindex',
        }
      ],
      title: this.profile ? this.profile.fullName : undefined,
      link: this.profile
        ? [
            {
              vmid: 'canonical',
              href: `${document.location.origin}${getMemberUrl(this.profile.vanityURL)}`,
              rel: 'canonical',
            },
          ]
        : [],
    };
  },
  props: [],
  components: {
    Loader,
    MemberProfileFollow,
    MemberProfileExpertise,
    MemberProfileInterests,
    MemberProfileExperience,
    MemberProfileCard,
    MemberProfileResources,
    NotFound,
  },
  data() {
    return {
      profile: null,
      notFound: false,
    };
  },
  computed: {
    ...mapState('member', ['member']),
    ...mapState('config', ['locale']),
    profileID() {
      return this.$route.params.vanityURL;
    },
    editMode() {
      return this.member?.id === this.profile.id;
    },
    activityBadges() {
      return this.profile.badgesByCategory['i18n.badge.activity'] || [];
    },
  },
  methods: {
    ...mapMutations('member', ['setMember']),
    async fetchProfile() {
      try {
        const { status, data } = await memberAPI.fetchMember(
          this.$route.params.vanityURL
        );
        if (status === 200) {
          this.profile = data;
        }
      } catch {
        this.notFound = true;
      }
    },
    reset() {
      this.profile = null;
    },
    onUpdated(profile) {
      this.profile = profile;
      if (this.member.id === profile.id) {
        this.setMember(profile);
      }
    },
  },
  watch: {
    profileID: {
      handler() {
        this.reset();
        this.fetchProfile();
      },
      immediate: true,
    },
  },
};
